/* product-card-v2.js */
(() => {
  const STORAGE_KEY = "pc_wishlist_handles_v1";

  const readWishlist = () => {
    try {
      return new Set(JSON.parse(localStorage.getItem(STORAGE_KEY) || "[]"));
    } catch {
      return new Set();
    }
  };

  const writeWishlist = (set) => {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify([...set]));
    } catch {}
  };

  const moneyText = (cents, currency) => {
    // Theme money formatting varies; we rely on server-rendered strings for display.
    // This helper exists only if you decide to display numeric in JS later.
    return `${currency || ""}${(cents / 100).toFixed(2)}`;
  };

  const setActiveSwatch = (card, btn) => {
    card.querySelectorAll("[data-pc-swatch]").forEach((b) => b.classList.remove("is-active"));
    btn.classList.add("is-active");
  };

  const updateFromVariant = (card, btn) => {
    const variantId = btn.getAttribute("data-variant-id");
    const variantUrl = btn.getAttribute("data-variant-url");
    const imageUrl = btn.getAttribute("data-image-url");

    const priceHtml = btn.getAttribute("data-price-html") || "";
    const compareHtml = btn.getAttribute("data-compare-html") || "";
    const isOnSale = btn.getAttribute("data-on-sale") === "true";
    const saleBadgeText = btn.getAttribute("data-sale-badge-text") || "";

    // Update link target (title/image click)
    const link = card.querySelector("[data-pc-link]");
    if (link && variantUrl) link.setAttribute("href", variantUrl);

    // Update image (best-effort)
   // "card" might be the details area; try to find the overall card root first.
const root = card.closest(".product-card") || card.closest("[ref='productCard']") || card.parentElement;
const img = (root && root.querySelector(".card-gallery img[data-pc-image]")) || document.querySelector(".card-gallery img[data-pc-image]");

    if (img && imageUrl) {
      img.setAttribute("src", imageUrl);
      // if your theme uses srcset/sizes, you may also want to update those here
    }

    // Update hidden variant for cart form
    const input = card.querySelector("input[data-pc-variant-input]");
    if (input && variantId) input.value = variantId;

    // Update price
    const priceWrap = card.querySelector("[data-pc-price-wrap]");
    if (priceWrap) {
      const newHtml =
        isOnSale
          ? `<span class="product-card-v2__priceSale">${priceHtml}</span><span class="product-card-v2__priceCompare">${compareHtml}</span>`
          : `<span>${priceHtml}</span>`;
      priceWrap.innerHTML = newHtml;
    }

    // Update sale badge
    const saleBadge = card.querySelector("[data-pc-sale-badge]");
    if (saleBadge) {
      if (isOnSale && saleBadgeText) {
        saleBadge.textContent = saleBadgeText;
        saleBadge.style.display = "";
      } else {
        saleBadge.style.display = "none";
      }
    }
  };

  const initWishlistState = () => {
    const wish = readWishlist();
    document.querySelectorAll("[data-pc-wishlist]").forEach((btn) => {
      const handle = btn.getAttribute("data-product-handle");
      if (handle && wish.has(handle)) btn.classList.add("is-active");
    });
  };

  document.addEventListener("click", (e) => {
    const swatch = e.target.closest("[data-pc-swatch]");
    if (swatch) {
      const card = swatch.closest("[data-product-card-v2]");
      if (!card) return;
      e.preventDefault();
      setActiveSwatch(card, swatch);
      updateFromVariant(card, swatch);
      return;
    }

    const heart = e.target.closest("[data-pc-wishlist]");
    if (heart) {
      e.preventDefault();
      const handle = heart.getAttribute("data-product-handle");
      if (!handle) return;

      const wish = readWishlist();
      if (wish.has(handle)) {
        wish.delete(handle);
        heart.classList.remove("is-active");
      } else {
        wish.add(handle);
        heart.classList.add("is-active");
      }
      writeWishlist(wish);
      return;
    }
  });

  document.addEventListener("DOMContentLoaded", initWishlistState);
})();
